import { IAppState } from '../../../AppModulesWrapper';

export function selectPhotos(state: IAppState): Array<string> {
  return state.servicePickerWidget.offer.photos || [];
}
